import BirthdayField from '@/fields/BirthdayField';
import BooleanField from '@/fields/BooleanField';
import CoiScanField from '@/fields/CoiScanField';
import DateField from '@/fields/DateField';
import EinField from '@/fields/EinField';
import EmailField from '@/fields/EmailField';
import FutureDateField from '@/fields/FutureDateField';
import IncodeField from '@/fields/IncodeField';
import IndividualizedAssessmentField from '@/fields/IndividualizedAssessmentField';
import InsurancePolicyNumberField from '@/fields/InsurancePolicyNumberField';
import IntegerField from '@/fields/IntegerField';
import SelectMultipleOptionsField from '@/fields/SelectMultipleOptionsField';
import SelectOptionField from '@/fields/SelectOptionField';
import StatementOfTruthField from '@/fields/StatementOfTruthField';

import AcademicProviderField from './AcademicProviderField';
import AddressField from './AddressField';
import BarLicenseDetailsField from './BarLicenseDetailsField';
import BulkEmailField from './BulkEmailField';
import ConsentField from './ConsentField';
import CprField from './CprField';
import ExternalProviderField from './ExternalProviderField';
import Field from './Field';
import FileField from './FileField';
import FullNameField from './FullNameField';
import MmcReferenceNumberField from './MmcReferenceNumberField';
import PastNameField from './PastNameField';
import PhoneNumberField from './PhoneNumberField';
import SelfieField from './SelfieField';
import SingleLineTextField from './SingleLineTextField';
import SmartAttributeField from './SmartAttributeField';
import SsnField from './SsnField';
import UsStateField from './UsStateField';

const types: Record<string, Field> = {
    'ssn': new SsnField(),
    'full-name': new FullNameField(),
    'past-name': new PastNameField(),
    'birthday': new BirthdayField(),
    'date': new DateField(),
    'cpr': new CprField(),
    'mmc-reference-number': new MmcReferenceNumberField(),
    'address': new AddressField(),
    'bar-license-details': new BarLicenseDetailsField(),
    'text': new SingleLineTextField(),
    'bulk-email': new BulkEmailField(),
    'consent': new ConsentField(),
    'us-state': new UsStateField(),
    'phone-number': new PhoneNumberField(),
    'file': new FileField(),
    'academic-provider': new AcademicProviderField(),
    'external-provider': new ExternalProviderField(),
    'selfie': new SelfieField(),
    'individualized-assessment': new IndividualizedAssessmentField(),
    'boolean': new BooleanField(),
    'ein': new EinField(),
    'integer': new IntegerField(),
    'string-enum': new SelectOptionField(),
    'string-enum-list': new SelectMultipleOptionsField(),
    'email': new EmailField(),
    'statement-of-truth': new StatementOfTruthField(),
    'future-date': new FutureDateField(),
    'insurance-policy-number': new InsurancePolicyNumberField(),
    'coi-scan': new CoiScanField(),
    'liveness-incode': new IncodeField(),
};

const smartAttributeTypes: Record<string, Field> = {};

export default function getField(type: string): Field | null {
    const smartAttribute = type.match(/^smart-attribute:(.+)$/);
    if (smartAttribute) {
        const smartAttributeName = smartAttribute[1];

        if (!smartAttributeTypes[smartAttributeName]) {
            smartAttributeTypes[smartAttributeName] = new SmartAttributeField(smartAttributeName);
        }

        return smartAttributeTypes[smartAttributeName];
    }

    return types[type] || null;
}
